import { ContentfulErroresLibranzasNode, ErroresLibranzasDictionary } from './erroresLibranzasAdapter.types';

interface RichTextNode {
    value?: unknown;
    content?: unknown;
}

/** Recorre el documento RichText y devuelve el primer `value` de texto no vacío. */
const findFirstText = (node: RichTextNode): string | undefined => {
    if (typeof node?.value === 'string' && node.value.trim()) return node.value;
    if (!Array.isArray(node?.content)) return undefined;
    for (const child of node.content) {
        const text = findFirstText(child as RichTextNode);
        if (text) return text;
    }
    return undefined;
};

/**
 * El diccionario de errores de libranzas viene modelado en Contentful como un array
 * JSON `[{ "<statusCode>": "<mensaje>" }, ...]` embebido como texto plano dentro de un
 * campo RichText (no hay content type dedicado). Códigos duplicados en el array: el
 * último gana, por orden de aparición.
 */
export const adaptErroresLibranzasDictionary = (
    node: ContentfulErroresLibranzasNode | undefined,
): ErroresLibranzasDictionary => {
    const raw = node?.tituloEnriquecido?.raw;
    if (!raw) return {};

    try {
        const text = findFirstText(JSON.parse(raw) as RichTextNode);
        if (!text) return {};

        const pairs = JSON.parse(text) as Array<Record<string, string>>;
        if (!Array.isArray(pairs)) return {};

        return pairs.reduce<ErroresLibranzasDictionary>((dictionary, pair) => ({ ...dictionary, ...pair }), {});
    } catch {
        return {};
    }
};
